import { Component, inject, Injectable } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";


@Injectable({providedIn: 'root'})

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    FormsModule, 
    CommonModule, 
    NgxSpinnerModule,
  ],
  providers: [
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {

  texts:any;
  email:string = '';

  activeModal:boolean = false;
  modalMessage:string = '';
  private http = inject(HttpClient);
  
  constructor(private langServ: LanguageService, private spinner: NgxSpinnerService) {
    this.texts = this.langServ.getWebisteTexts();
  }

  submiteNewsletter(){
    this.spinner.show();

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(this.email)) {
      this.activeModal = true;
      if (this.langServ.getLanguage() == 'es') {
        this.modalMessage = 'Dirección de correo electrónico es invalida. Por favor intente de nuevo.';
      }
      else{
        this.modalMessage = 'The email address is invalid. Please try again';
      }
      this.spinner.hide();
    }else{
      const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
      const body = `email=${encodeURIComponent(this.email)}`;
      this.http.post('https://mundoev.com/module/mundoev_subscribe/api', body, { headers }).subscribe(
        (result: any) => {
          if (result.success) {
            this.activeModal = true;
            this.modalMessage = this.texts.footer.newsletter.success_message;
            this.spinner.hide();
            this.email = '';
          }
        },
        (error) => {
          this.activeModal = true;
          this.modalMessage = this.texts.footer.newsletter.error_message;
          this.spinner.hide();
        },
        () => {
          this.spinner.hide();
        }
      );
    }
  }

  closeModal() {
    this.activeModal = false;
    
  }

  getCurrentYear(): number {
    return new Date().getFullYear(); 
  }

}
